import { Button, Card, Space } from 'antd'
import { QueuableRequestStatus } from 'shared'
import { useAuthContext } from 'context/AuthContext'
import GenericRequestCardItem from './components/GenericRequestCardItem'
import { useState } from 'react'
import { GenericRequestCardProps, GenericRequestFields } from './types'
import CIMSSection from 'components/CIMSSection'
import { HelpMessage } from 'utils/constants'
import { dateFormatter } from '../../../../../../../../../utils/dateFormatter'

function GenericRequestCard<T extends GenericRequestFields>({
  request,
  options,
  onCancel,
  refetch,
}: GenericRequestCardProps<T>) {
  const {
    requestedBy: { id: requestedById, mail, displayName },
    statusId,
    createdDate,
    estimatedString,
    startedDate,
  } = request
  const { user } = useAuthContext()
  const { Generating, Queued } = QueuableRequestStatus
  const { name: status } = QueuableRequestStatus.fromIdOrFail(statusId)
  const queued = statusId === Queued.id
  const requestOptions = options?.(request)
  const [loading, setLoading] = useState(false)
  return (
    <Card
      style={{ width: '100%' }}
      title={status}
      size={queued ? 'small' : undefined}
      extra={
        user?.id === requestedById && queued ? (
          <Button
            type="primary"
            loading={loading}
            disabled={loading}
            onClick={async () => {
              setLoading(true)
              await onCancel?.(request)
              setLoading(false)
              refetch?.()
            }}
          >
            Cancel Request
          </Button>
        ) : null
      }
    >
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <GenericRequestCardItem label="Requested By">
          {displayName ?? mail}
        </GenericRequestCardItem>
        <GenericRequestCardItem label="Created Date">
          {dateFormatter.shortDatetime(createdDate)}
        </GenericRequestCardItem>
        {statusId === Generating.id && (
          <GenericRequestCardItem label="Started">
            {dateFormatter.shortDatetime(startedDate)}
          </GenericRequestCardItem>
        )}
        <GenericRequestCardItem label="Estimated Time to Finish">
          {estimatedString}
        </GenericRequestCardItem>
        {requestOptions && (
          <CIMSSection title="Options" help={HelpMessage.Exports.Options}>
            {requestOptions.map(
              ({ children, label, hidden }, i) =>
                !hidden && (
                  <GenericRequestCardItem key={`${label}-${i}`} label={label}>
                    {children}
                  </GenericRequestCardItem>
                )
            )}
          </CIMSSection>
        )}
      </Space>
    </Card>
  )
}

export default GenericRequestCard
